import { useCallback, useState } from 'react';
import { useUnpublishSmartLinkMutation } from '../../../redux/api/fymAPI';
import { isSuccessfulResult } from '../../../redux/api/utils/isSuccessfulResult';

/**
 * Taking a page offline from the manage screen.
 *
 * The artist stays where they are: the screen's Live pill flips to Draft as
 * soon as the endpoint answers, because the response replaces the cached page
 * the header reads.
 */
export function useUnpublishPageFlow({ accountId, smartLinkId }: { accountId: number; smartLinkId: number }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [unpublishSmartLink, { isLoading, error }] = useUnpublishSmartLinkMutation();

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const unpublish = useCallback(() => {
    unpublishSmartLink({ accountId, smartLinkId })
      .then((result) => {
        if (!isSuccessfulResult(result)) {
          return;
        }
        setIsModalOpen(false);
      })
      .catch(console.error);
  }, [accountId, smartLinkId, unpublishSmartLink]);

  return { isModalOpen, openModal, closeModal, unpublish, isUnpublishing: isLoading, unpublishError: error };
}
